import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>
                <em>3.1 Landscape dynamics</em>
              </strong>
            </p>
            <p>
              Temporal land use, depicted in Fig. 5, reveals that the landscape
              of Bangalore has transitioned from a porous landscape (with 68%
              vegetation cover, 274 lakes/wetlands, and &lt; 8% built-up) to a
              paved contiguous surface (&lt;3% vegetation cover, 193 lakes, 86%
              paved surface) with the loss of vegetation cover (88%), and water
              cover (79%).
            </p>
            <p>
              Unplanned developmental activities during the post-2000s, due to
              concentrated developmental activities for IT parks and SEZ&rsquo;s
              development in the city, have given impetus to rapid urbanization
              with drastic and unrealistic land use changes. The growth has
              surpassed the carrying capacity, which is evident from the acute
              scarcity of natural resources (oxygen deficiency, water table
              decline, declining environmental quality, etc.), inadequate
              infrastructure, and basic amenities.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis5.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 5:</em>
                      </strong>{" "}
                      Land use dynamics in the rapidly urbanizing landscape of
                      Bangalore during 1973 to 2023.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>3.2 Spatial analyses of wetlands</em>
              </strong>
            </p>

            <p>
              Fig. 6 illustrates the sharp decline (by 70.4%) in the number of
              waterbodies from 1973 to 2023.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis6.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 6:</em>
                      </strong>{" "}
                      Spatial distribution of lakes in 1973 and 2023.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              The decline in water bodies in Bangalore is mainly due to intense
              urbanization and urban sprawl. Field survey reveals that lakes
              (98%) have been encroached on for illegal buildings (high-rise
              apartments, commercial buildings, slums, etc.), nearly 90% of
              lakes are sewage-fed (Fig. 7), slums surround 38% of lakes, and
              82% are wetlands, showing a sharp decline in vegetation cover in
              the catchment. Also, lake catchments have been used as dumping
              yards for either municipal solid waste or building debris.
              Multi-story buildings have come up in many lake beds, and
              stormwater drains hinder the natural catchment flow. The decline
              in wetlands is correlated with the increase in built-up area due
              to the concentrated growth model (focusing on Bangalore) adopted
              by the state executive system, which severely affects open spaces,
              particularly water bodies. Rapid urbanization has resulted in land
              use changes with encroachments and a loss of interconnectivity
              among lakes, apart from the sustained inflow of untreated
              wastewater into lakes, resulting in pollution that has affected
              aquatic biodiversity, evident from the decline of native species
              <sup>32,65,68</sup>.
            </p>
            <p>
              <strong>
                <em>3.3 Water quality of Bangalore Lakes</em>
              </strong>
            </p>
            <p>
              In Bangalore city, the water quality results reveal that 90% of
              lakes are fed with sewage and only 10% are devoid of sewage (Fig.
              7). Assessment of water quality in 105 lakes in Bangalore revealed
              that about 25 lakes were found to be in a very bad state (lakes
              had little or no water)<sup>32,65,68</sup>.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis7.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 7:</em>
                      </strong>{" "}
                      Water quality of Bangalore lakes.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              The physicochemical characteristics of 80 lakes were assessed to
              understand the prevailing condition of lakes in Bangalore. The
              water quality results revealed that lakes such as Andrahalli,
              Baallehannu, Doraikere, Hebbal, Hemmigepura, Herohalli,
              Hesaraghatta, Jakkur, Kaikondrahalli, Kogilu, Lalbagh, Nagavara,
              Narsipura 1, Rachenahalli, and Yediyur fall under Class D and E.
              In contrast, all the other 63 lakes fall under Class E based on
              the Classification of Inland Surface Water (CPCB, Central
              Pollution Control Board). Lakes in Koramangala-Challaghatta Valley
              are more polluted than the lakes in Vrishabavathi Valley and
              Hebbal Valley. About 79% of lakes monitored in Bangalore belong to
              class E, 19% to classes D and E, and 2% belong to class A. Lakes
              like Bellandur, Chelekere, Chikkabegur, Chunchugatta, Hebbagodi,
              Kalkere, Kammasandra Lake-1, Kengeri, Mallathhalli,
              Maragondanahalli, Nallurahalli, Rampura, Varthur, and
              Yelemallappachetty receive an enormous amount of untreated sewage
              water<sup>32,65,68</sup>.
            </p>
            <p>
              Lakes with the profuse growth of algae, i.e., Cyanophyceae (due to
              continuous sewage inflow and high nutrients), are Sankey,
              Dasarahalli, Bagmane, Ulsoor, Anchepalya, Bommasndra, Kammasandra
              1 and Kammasandra 2. About 25 lakes were extensively used for
              solid and liquid waste dumping and were fully covered with
              invasive species of macrophytes due to the excessive amount of
              nutrients. Lakes such as Lakasandra had completely turned into
              barren land due to the dumping of building debris
              <sup>32,65,68</sup>.
            </p>
            <p>
              <strong>
                <em>3.4 Biodiversity in Bangalore Lakes</em>
              </strong>
            </p>
            <p>
              Lakes provide habitat for numerous aquatic organisms. Globally,
              freshwater biodiversity is threatened due to factors such as
              overexploitation, water pollution, habitat destruction or
              degradation, flow modification, and invasion by exotic species
              <sup>33</sup>.
            </p>
            <p>
              <strong>3.4.1 </strong>Microalgae diversity
            </p>
            <p>
              Microalgae (or phytoplankton) are primary producers
              (photosynthetic organisms) and bioindicators in water bodies. They
              provide food and transfer energy to the various trophic levels.
              The wide applications of microalgae are in the pharmaceutical and
              nutraceutical industries<sup>34</sup>. Chlorophyta, which makes up
              44% of the total algae in Bangalore lakes, constitutes the most
              prevalent phylum of algae (in Fig. 8), followed by Bacillariophyta
              (21%), Cyanobacteria (19%), Euglenozoa (10%), and Others (6%,
              which include Ochrophyta, Glaucophyta, and Charophyta). The water
              quality of lakes largely determines the variations in species
              composition and diversity. Microalgae are useful as bioindicators
              because of their swift response to environmental changes.
              Microalgae efficiently utilize nutrients, aiding in remediation
              <sup>35</sup>.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis8.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 8:</em>
                      </strong>{" "}
                      Microalgae diversity in lakes of Bangalore.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>3.4.2 </strong>Zooplankton diversity
            </p>
            <p>
              Zooplankton are primary consumers, feeding on microalgae or
              phytoplankton. Like microalgae, zooplankton also serve as
              effective bioindicators of water quality<sup>36</sup>. Rotifera is
              the most dominant group of zooplankton (Fig. 9), accounting for
              43%, followed by Copepoda (28%), Cladocera (12%), Protozoa (11%),
              and others (6%, Ostracoda and Chironomid larvae). Rotifer
              abundance and richness are high on complex macrophytes, providing
              habitat, food, and protection against predators. Submerged
              macrophytes provide refuge for small zooplankton and potential
              predators<sup>37</sup>.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis9.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 9:</em>
                      </strong>{" "}
                      Zooplankton diversity in lakes of Bangalore.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>3.4.3 </strong>Ichthyofauna or fish diversity
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis10.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 10:</em>
                      </strong>{" "}
                      Ichthyofauna diversity in lakes of Bangalore.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              Fish are excellent sources of protein, vitamins, and minerals.
              Changes in biotic and abiotic factors affect habitat quality and
              may, in turn, affect the growth, reproduction, and survival of
              fish<sup>38</sup>. The present study records 18 species of
              ichthyofauna. Cypriniformes (43%) is the most dominant order (Fig.
              10), followed by Perciformes (33%), Cyprinodontiformes (15%), and
              Siluriformes (11%). A total of ten fish species are of least
              concern (LC), which include <em>Catla catla</em>,{" "}
              <em>Clarias batrachus</em>, <em>Clarias gariepinus</em>,{" "}
              <em>Labeo fimbriatus</em>, <em>Labeo rohita</em>,{" "}
              <em>Parambassis ranga</em>, <em>Cirrhinus mrigala</em>,{" "}
              <em>Heteropneustes fossilis</em>, <em>Puntius ticto</em>, and{" "}
              <em>Gambusia affinis</em>. Two species are classified as not
              evaluated (<em>Ctenopharyngodon idella</em> and{" "}
              <em>Oreochromis niloticus</em>), one species is near threatened
              (NT), and one species is vulnerable (
              <em>Cyprinus carpio communis</em>).
            </p>
            <p>
              <strong>3.4.4 </strong>Macrophyte diversity
            </p>
            <p>
              Macrophytes are aquatic plants growing in the shallow euphotic
              zone of freshwater. Aquatic macrophytes significantly increase
              habitat complexity, impacting the taxon richness and density of
              organisms in plant beds. Fish and other aquatic macroinvertebrates
              find refuge from macrophytes, which also mobilize mineral elements
              from the bottom sediments. The most dominant order is Poales
              (29%), which includes species like <em>Typha angustata</em>,{" "}
              <em>Cyperus rotundus</em>, <em>Typha</em> sp.,{" "}
              <em>Cyperus alternifolius</em>, <em>Cyperus articulates</em>,{" "}
              <em>Cyperus papyrus</em>, <em>Chrysopogon zizanioides</em>,{" "}
              <em>Echinochloa colona</em>, <em>Eleocharis</em> sp., and{" "}
              <em>Paspalum</em> sp. Others (31%) include Salviniales, Lamiales,
              Zingiberales, Ceratophyllales, Poales, Commelinales, Apiales,
              Solanales, Myrtales, Proteales, Nymphaeales, and Asterales and
              occur very few in number (Fig. 11).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis11.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 11:</em>
                      </strong>{" "}
                      Macrophyte diversity in lakes of Bangalore.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>3.4.5 </strong>Bird Diversity
            </p>
            <p>
              Birds provide several ecosystem services such as pollination
              (ornithophily), seed dispersal, nutrient cycling, food (meat,
              eggs) provision, scavenging, pest control, and ecotourism
              <sup>39,40</sup>. Waterbirds are efficient bioindicators of
              ecological conditions, control pests<sup>41</sup>, and act as
              sentinels of potential disease outbreaks<sup>42</sup>. Bangalore
              urban lakes provide habitat for a variety of birds, which include
              Paddy field pipit or Oriental pipit (<em>Anthus rufulus</em>),
              Purple gallinule (<em>Porphyrio martinicus</em>), White-breasted
              waterhen (<em>Amaurornis phoenicurus</em>), Red-wattled lapwing (
              <em>Vanellus indicus</em>), Brahminy kite (
              <em>Haliastur indus</em>), Black kite (<em>Milvus migrans</em>),
              Little cormorant (<em>Microcarbo niger</em>), Little egret (
              <em>Egretta garzetta</em>), and Cattle egret (
              <em>Bubulcus ibis</em>). Lakes in Bangalore, such as Jakkur,
              Lalbagh, Madiwala, Kaikondrahalli, Kasavanahalli, etc., are home
              to pelicans and painted storks (Fig. 12).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis12.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 12:</em>
                      </strong>{" "}
                      Winter visitors to Bangalore lakes.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>
                <em>3.5 Ecosystem services from Bangalore lakes</em>
              </strong>
            </p>
            <p>
              Wetlands are the most diverse and productive ecosystems, which
              provide several ecological, economic, and social benefits to
              society. Wetlands provide vital ecosystem services and processes,
              such as nutrient cycling, water purification, reducing pollution,
              carbon sequestration, groundwater recharge, flood reduction,
              erosion control, habitats for aquatic flora/fauna, opportunities
              for education, aesthetics, and recreation. Provisioning services
              (products obtained from ecosystems) include water, food, fuel,
              fibre, genetic resources, biochemical components, and medicines.
              Regulating services (benefits from various ecosystem processes)
              include water regulation, climate regulation, water purification,
              disease regulation, erosion control, carbon sequestration, and
              flood control. Cultural services (nonmaterial benefits) include
              recreation, aesthetic experiences, spiritual value, and
              ecotourism. The valuation of ecosystem services (Fig. 13) was done
              through the residual value and benefit transfer methods
              <sup>1</sup>. The provisioning services provided by Lakes of
              Bangalore ranged from Rs 0.731&ndash;1472.23 Lakhs per year
              depending on the spatial extent and condition of ecosystems. The
              regulating services ranged from Rs 2.66&ndash;5353.779 Lakhs per
              year. The cultural services ranged from Rs 0.512&ndash;1031.24
              Lakhs per year. The total value of provisioning, regulating, and
              cultural services provided by the lakes of Bangalore is Rs.
              6829.531 Lakhs per year, Rs. 24835.659 Lakhs per year, and Rs.
              4783.821 Lakhs per year, respectively. The TESV (total ecosystem
              supply value) of Bangalore lakes amounts to Rs. 36449.004 Lakhs
              per year (Rs. 3.904&ndash;7857.248 Lakhs per year), and the NPV
              (net present value) is Rs. 93782.4 million (10.0&ndash;20216.5
              million). Natural capital accounting and valuation of ecosystem
              services aid in accounting for degradation costs in development,
              which is crucial for developing appropriate policies toward the
              prudent management of fragile life-support ecosystems. The
              instances of decline in wetland goods and services as a result of
              mismanagement leading to serious water pollution have affected the
              livelihood of the dependent people as well as the economic
              development of a region, as in the case of Amruthalli Lake, which
              provides goods worth Rs. 20/ha/day compared to the pristine
              wetland (Rachenahalli Lake) of Rs. 10,435/ha/day, which highlights
              the need for prudent management of wetlands to sustain the
              livelihood of the dependent local population<sup>43</sup>.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis13.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 13:</em>
                      </strong>{" "}
                      Methods for valuing the ecosystem services of wetlands.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>3.6 Threats to Wetlands of Bangalore</em>
              </strong>
            </p>
            <p>
              Unplanned developmental activities leading to rapid urbanization
              and urban sprawl have led to increased migration (with improved
              job opportunities), leading to pressure on infrastructure,
              inadequate basic amenities, and challenges like escalating
              pollution, traffic congestion, higher instances of chronic
              diseases (such as respiratory ailments, cancer, kidney failure,
              etc.), inadequate drainage systems, waste (solid and liquid)
              mismanagement, encroachment of stormwater drains, floodplains,
              lakebeds, a decline of natural flood-storage locations, the loss
              of permeable/pervious areas, recurring instances of flooding, etc.
              <sup>44</sup>. Industrialization coupled with the burgeoning
              population has increased wastewater, which is being discharged
              indiscriminately to surface water bodies, resulting in water
              pollution that poses a health hazard to aquatic biota and humans.
              Land cover changes leading to land degradation and deforestation
              have contributed to siltation, resulting in sedimentation, which
              has reduced the storage capacity of waterbodies and caused a
              decline in groundwater recharge. The loss of lakes and the removal
              of vegetation cover in the watershed have lowered the water
              retention capacity of the watershed. Urbanization has resulted in
              the decline of native biodiversity (flora and fauna), migrating
              bird populations, and groundwater table. Changes in land use and
              land cover (LULC) in wetland catchments are causing environmental
              concerns such as biodiversity loss, water and soil pollution, and
              climate change<sup>45</sup>. An analysis of Land Surface
              Temperature (LST) in Greater Bangalore indicated increased
              temperatures in urbanized regions (built-up areas) and decreased
              temperatures in regions covered with vegetation and water bodies
              <sup>20</sup>. Variations in LST for different LULC types were
              evident during different seasons. It was found that LST and
              Normalized Difference Vegetation Index (NDVI) were negatively
              correlated<sup>46,47</sup>.
            </p>
            <p>
              <strong>3.6.1 </strong>Depletion of Groundwater
            </p>
            <p>
              The loss of water bodies in Bangalore has resulted in a sharp
              decline in the groundwater table. Over 20 years following the
              reclamation of the lake and its watershed for commercial purposes,
              the water table has dropped to 200 m in five years from 28 m.
              After two decades of lake reclamation, the local community has
              lost groundwater, which is evident from the absence of water even
              at a depth of 600&ndash;700 m. Furthermore, the groundwater table
              in densely populated areas like Whitefield has decreased below 400
              to 500 m<sup>44</sup>. Surface water and groundwater (SW-GW) are
              vital components of the water cycle, and their interactions are
              primarily controlled by groundwater depth, local geology,
              proximity to other freshwater sources, and seasonal variation in
              precipitation. These, in turn, affect ecosystem health, quantity,
              and quality of water<sup>48</sup>. Water movement between ground
              and surface water sustains water during the post-monsoon period in
              surface water bodies, and it facilitates chemical transfer between
              terrestrial and aquatic systems, impacting carbon, oxygen,
              nutrients, and biogeochemical processes, ultimately affecting
              aquatic systems' biological and chemical characteristics
              <sup>49</sup>. The changes in climate due to the sustained
              onslaught of anthropogenic activities have significantly altered
              SW-GW interactions due to a lack of infiltration during monsoons
              (due to land degradation), which impaired the functioning of
              lakes. With the increase in temperature and alteration in the
              hydrologic regime, the spatial extent of the water spread area has
              declined with the decline in levels of groundwater and surface
              water<sup>50</sup>.
            </p>
            <p>
              <strong>3.6.2 </strong>Loss of interconnectivity of lakes
            </p>
            <p>
              The interconnectivity among lakes is lost due to unauthorized
              occupation or dumping of solid waste (building debris) in the lake
              bed, and stormwater drains have hindered the movement of water
              across lakes, resulting in recurring instances of floods even
              during periods of regular rainfall<sup>44</sup>. The loss of
              interconnectivity among lakes has also affected the movement of
              fauna and water quality (due to the lack of aeration).
            </p>
            <p>
              <strong>3.6.3 </strong>Alteration in the chemical integrity due to
              the sustained disposal of untreated domestic sewage and industrial
              effluents into lakes
            </p>
            <p>
              Wastewater from commercial, industrial, residential, and
              agricultural sectors containing organic and inorganic materials is
              being discharged directly into storm water drains and lakes,
              altering the chemical composition of lakes<sup>51</sup>. The
              sustained inflow of wastewater has led to nutrient enrichment,
              resulting in eutrophication with algal blooms, a decline of
              dissolved oxygen (DO), the generation of malodorous gases, and the
              widespread proliferation of invasive macrophytes, which hinders
              the functioning of lakes. Sewage contains carbon (C), nitrogen
              (N), and phosphorus (P)<sup>52</sup>, which enhances organic
              contaminants and chemical constituents, resulting in the loss of
              biodiversity, microbial community structure, disease vectors,
              pathogens, and flies, which causes waterborne diseases
              <sup>53</sup>. Health implications are evident from several cases
              of fever, diarrhea, and skin disorders in the Varthur Lake
              catchment due to eutrophic status<sup>54</sup>. A similar
              situation prevails in Hebbal Lake, with a poor overall water
              quality index<sup>55</sup>. The high levels of phosphates in
              Varthur and Bellandur lakes manifested in eutrophic conditions
              with foam formation, abundant growth of invasive macrophytes, and
              higher levels of chemical pollutants and nutrients (N and P) were
              reported in foam samples<sup>56</sup>.
            </p>
            <p>
              <strong>3.6.4 </strong>Water and land contamination due to the
              sustained dumping of municipal solid waste and blockage of storm
              water drains with the disposal of construction and demolition
              (C&amp;D) waste
            </p>
            <p>
              Municipal solid waste contributes to global greenhouse gas (GHG)
              emissions. The total methane emissions from municipal solid waste
              account for 0.9 Tg/year<sup>57</sup>. The leachate released had a
              high concentration of organic and inorganic constituents and trace
              metals contaminating the surface and groundwater<sup>58</sup>.
              Sustained dumping of solid wastes in water bodies and stormwater
              drains has hindered water movement and contaminated the air, land,
              and water environment<strong>.</strong>
            </p>
            <p>
              <strong>3.6.5 </strong>Recurring instances of fish mortality
            </p>
            <p>
              Fish mortality in Sankey, Ulsoor, and Devarabisanahalli lakes in
              Bangalore was due to asphyxiation, with a decline in dissolved
              oxygen (DO) levels and an increase in ammonia due to the sustained
              inflow of untreated sewage<sup>59-62</sup>.
            </p>
            <p>
              <strong>3.6.6 </strong>Introduction of exotic species
            </p>
            <p>
              The introduction of exotic species impairs the native food chain,
              resulting in the disappearance of native or indigenous species.
              Exotic fish species prevalent in Bangalore wetlands are{" "}
              <em>Ctenopharyngodon idella</em>, <em>Cyprinus carpio</em>,{" "}
              <em>Oreochromis</em> sp., <em>Clarias gariepinus</em>,{" "}
              <em>Gambusia affinis</em>, and{" "}
              <em>Hypophthalmichthys molitrix</em>
              <sup>38</sup>. The profuse growth of invasive exotic plant species
              and exotic fish with the sustained discharge of nutrient-rich
              wastewater has contributed to the extinction of native faunal
              species<sup>54</sup>. The exotic fish species compete with the
              native fish, prey on native fish, introduce new diseases and
              parasites, alter trophic structure, and cause genetic erosion of
              indigenous species<sup>63</sup>. Exotic species of macrophytes,
              such as <em>Salvinia molesta</em> and{" "}
              <em>Eichhornia crassipes</em>, have choked watercourses and
              threatened the sustainability of lakes<sup>64</sup>.
            </p>
            <p>
              <strong>3.6.7 </strong>Inappropriate restoration of lakes
            </p>
            <p>
              Lake restoration entails (i) arresting pollutants, (ii)
              decontaminating the lake, (iii) desilting to remove accumulated
              silt and enhance water storage capacity, (iv) improving water
              percolation to enhance groundwater recharge, (v) maintaining the
              physical integrity of the lake, (vi) re-establishing the habitat
              quality of aquatic organisms, and maximizing aquatic biodiversity.
              An environmental audit of the efficacy of rejuvenation revealed
              that most of the lakes had a poor water quality index, WQI (53% of
              lakes fell under very poor water quality, 37% under poor water
              quality, and only 10% had good water quality), which indicates
              inappropriate decontamination and poor maintenance of restored
              lakes. The current rejuvenation of lakes faces several gaps,
              including a lack of understanding of functional aspects such as
              ecological, hydrological, and remediation aspects; a focus on
              utilizing allocated funds without scientific evaluation; failure
              to decontaminate the lake (partial removal of contaminated silt);
              not arresting fresh pollutants; continued inflow of partially
              treated or untreated sewage and industrial effluents; and the
              removal of riparian vegetation. The emphasis of the current
              rejuvenation endeavor is on converting the lake to a "cement bowl"
              rather than restoring the ecology and improvement of hydrologic
              regime. The creation of jogging paths and beautification rather
              than ecological restoration contributes to the challenges faced in
              lake rejuvenation<sup>65</sup>. Appropriate ecological restoration
              strategies based on natural principles are crucial to restoring
              and safeguarding physical, chemical, and biological integrity of
              wetlands.
            </p>
            <p>
              <strong>
                <em>
                  3.7 Wastewater treatment based on nature-based principles{" "}
                </em>
              </strong>
            </p>
            <p>
              Conventional wastewater treatment options are energy and
              capital-intensive, apart from their inability to remove nutrients
              altogether and generate concentrated waste streams necessitating
              environmentally sound disposal. Compared to this, an integrated
              wetland system (Fig. 14) would help in the cost-effective tertiary
              treatment (removal of N, P, and heavy metals), which prevents
              contamination of lake water and groundwater resources. Algae grow
              rapidly and uptake nutrients (C, N, and P) in the wastewater.
              Algae convert nitrate into organic compounds (proteins, lipids)
              through photosynthesis. Algae exhibit higher growth rates than
              other plants due to their extraordinarily efficient light and
              nutrient utilization. Algal bacterial symbiosis is very effective
              as algae generate O<sub>2</sub> (during photosynthesis), which
              aids in the efficient oxidation of organic matter with the help of
              the chemo-organotrophic bacteria and provides algae with an
              enriched supply of CO<sub>2</sub>, minerals, and nutrients.
            </p>
            <p>
              The integrated wetland system (1.6 ha) consists of an STP (Upflow
              Anaerobic Sludge Blanket Reactor (UASB) with an extended aeration
              system) integrated with the constructed wetlands and algal pond,
              which has helped cost-effectively remove nutrients and chemical
              ions. Emergent macrophytes (such as typha) act as filters to
              remove suspended matter and avoid anaerobic conditions caused by
              root zone oxidation and algae taking the dissolved nutrients. Four
              to five days of residence time help remove pathogens apart from
              nutrients. The macrophytes in the wetland area and at the outfalls
              of the lake include <em>Typha augustata</em> species (54%),
              followed by <em>Alternanthera philoxeroides</em> (28%). Floating
              macrophytes like <em>Eicchornia crassipes</em> (84%) were
              restricted to the outlet reaches. A nominal residence time (~5
              days) would help remove pathogens apart from nutrients.
              Replication of this model in Bangalore would help meet the water
              demand and also help in recharging groundwater sources without any
              contamination<sup>51,66,67</sup>. Measures required to mitigate
              the current water crisis are: (i) rainwater harvesting (15 TMC) at
              decentralized levels through rejuvenated lakes would help in
              improving the groundwater table; (ii) an integrated wetlands
              ecosystem consisting of constructed wetlands and algal ponds helps
              treat wastewater through bioremediation. Replicating the Jakkur
              wetland ecosystem would help treat and reuse water. Rejuvenating
              lakes will have the added advantage of maintaining groundwater
              quality in the vicinity. The integrated wetland system at Jakkur
              provides an opportunity to assess treatment efficacy and insights
              for replicating similar systems to address the impending water
              scarcity in the rapidly urbanizing city of Bangalore.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis14.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 14:</em>
                      </strong>{" "}
                      Integrated wetland system.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <p>
              <strong>
                <em>3.8 Sustainable management of Bangalore lakes</em>
              </strong>
            </p>
            <p>
              Despite good environmental legislation, the loss of ecologically
              sensitive wetlands is due to the uncoordinated pattern of urban
              growth happening in Bangalore. The principal reason is a lack of
              good governance and decentralized administration, evident from a
              lack of coordination among many para-state agencies, which has led
              to unsustainable use of land and other resources. Failure to deal
              with water as a finite resource leads to the unnecessary
              destruction of lakes and marshes that provide us with water. This
              failure, in turn, threatens all options for the survival and
              security of plants, animals, humans, etc.
            </p>
            <p>
              The sustainable management of lakes at disaggregated levels would
              help maintain the groundwater table, apart from other ecosystem
              services. Good governance at decentralized levels with informed
              decision-making requires the organisation of data and knowledge
              from disparate sources through decision-support systems, which
              enhances the decision-making capabilities. Bangalore Lakes
              Information System (BLIS) is designed by taking advantage of
              recent advances in information and open-source web technologies
              through the integration of spatial with the attribute information
              (physical, chemical, and biological aspects) of Bangalore lakes at
              disaggregated levels, which helps in prudent management while
              enhancing governance transparency and meeting societal needs.
            </p>
            <p>
              Web-based BLIS available online
              (https://wgbis.ces.iisc.ac.in/sdss/BLIS/) is designed by
              integrating free and open-source software (GeoServer, PostgreSQL,
              PostGIS, and Leaflet) and the integration of spatial information
              according to Open Geospatial Consortium (OGC) standards to carry
              out a multiple criteria analysis. Features such as Web Map Service
              (WMS) and Web Feature Service (WFS) would help in the effective
              dissemination of information about Bangalore lakes pertaining to
              water quality, ecosystem services, biodiversity (microalgae,
              zooplankton, ichthyofauna, macrophytes, and birds).
            </p>
            <p>
              The Graphic User Interface (GUI) of the Bangalore Lakes
              Information System (BLIS), as depicted in Fig. 15, consists of (i)
              a navigation bar and options for WMS and WFS. Interactive options
              include selecting lakes based on valley and provide details of
              water quality, biodiversity, and ecosystem services (Fig. 16).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis15.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 15:</em>
                      </strong>{" "}
                      Bangalore Lake Information System (BLIS).
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              BLIS contains the identification keys, ecological importance,
              economic importance, and photographs (maximum 6) of all species of
              microalgae, zooplankton, ichthyofauna, macrophytes, and birds of
              Bangalore city. BLIS aids in the prudent management of natural
              resources as per Sustainable Development Goal 6 (SDGs) of the
              United Nations (2015), focusing on ensuring a clean, stable water
              supply and effective sanitation for all people by 2030, and helps
              in ensuring intergeneration equity by maintaining clean air, land,
              and water.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/blis16.png" alt="" />
            </p>

            <table>
              <tbody>
                <tr>
                  <td width="1101">
                    <p style={{ textAlign: "center" }}>
                      <strong>
                        <em>Figure 16:</em>
                      </strong>{" "}
                      WMS and WFS option of a chosen lake in BLIS.
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>4 Recommendations</strong>
            </p>
            <p>Recommendations for prudent management of waterbodies are:</p>
            <p>
              <ol>
                <li>
                  Inventorying, mapping, and monitoring of valley zones and
                  removing encroachments in lake beds, stormwater drains (and
                  rajakaluves / major water drains).
                </li>
                <li>
                  Re-establish interconnectivity among lakes to mitigate
                  flooding in regions.
                </li>
                <li>
                  Maintaining the riparian vegetation and the integrity of
                  floodplains and buffer zones.
                </li>
                <li>
                  Prohibit practices include hunting wild animals, dumping solid
                  waste, directly discharging untreated sewage, converting lakes
                  for uses other than as lakes, and reclaiming lakes.
                </li>
                <li>
                  Control any activity that impedes regular run-off and
                  associated biological processes in the buffer zone 200 metres
                  from the lake's edge or flood plains.
                </li>
                <li>
                  Restrict the inflow of untreated sewage into lakes. Allow only
                  treated water to enter lakes to minimize pollution. It is
                  better to implement the polluter pays principle for polluters
                  to maintain the chemical integrity through pollution
                  reduction.
                </li>
                <li>
                  Restrict dumping of municipal solid waste as well as
                  construction and demolition (C&amp;D) wastes in lake beds,
                  storm water drains, and valley zones.
                </li>
                <li>
                  Flood mitigation involves restoring lakes, removing drainage
                  blockages, removing encroachments, preventing waste disposal
                  in stormwater drains and lake beds, restoring lake catchment,
                  and restoring lake connectivity to prevent flooding.
                </li>
                <li>
                  Prohibit the introduction and cultivation of exotic species of
                  flora and fauna that reduce the population of native species.
                </li>
                <li>
                  Promote afforestation activities, i.e., plant native species
                  of flora in the lake catchment.
                </li>
                <li>
                  Adopt measures to control the overgrowth of aquatic plants or
                  weeds in lakes through manual operations.
                </li>
                <li>
                  Public awareness as well as awareness among educational and
                  business institutions, are necessary for the conservation of
                  these lakes to be successful in the long run. Education is
                  necessary for site managers as well as policymakers at
                  different levels.
                </li>
                <li>
                  Stakeholders, the local community, and the corporate sector
                  should be involved in the effective management plan, requiring
                  continuous monitoring of wetland systems. Research is
                  essential to understanding the dynamics of these ecosystems
                  and formulating national policy.
                </li>
              </ol>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
